import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import MissingItemsTable from './components/MissingItems'

const MissingItemsTableList = (props) => (

    <div>
        <Container>
            <MissingItemsTable {...props} />
        </Container>
    </div>
);

MissingItemsTableList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(MissingItemsTable);

